import type { TranslationValues } from '@shared/config/i18n'
import { z } from 'zod'

const phoneRegex = new RegExp(/^01([0|1|6|7|8|9])(-?[0-9]{3,4})(-?[0-9]{4})$/)
type Translate = (key: string, values?: TranslationValues) => string

export const createRegisterDeliveryInformationFormSchema = (t: Translate) =>
  z.object({
    name: z.string().min(1, { message: t('delivery.validation.nameRequired') }),
    phone: z.string().regex(phoneRegex, { message: t('delivery.validation.phoneInvalid') }),
    zipCode: z.string().min(1, { message: t('delivery.validation.zipCodeRequired') }),
    address: z.string().min(1, { message: t('delivery.validation.addressRequired') }),
    detailAddress: z.string().min(1, { message: t('delivery.validation.detailAddressRequired') }),
  })

export const registerDeliveryInformationFormSchema = createRegisterDeliveryInformationFormSchema((key) => key)

export type RegisterDeliveryInformationFormValues = z.infer<
  ReturnType<typeof createRegisterDeliveryInformationFormSchema>
>
export type RegisterDeliveryInformationFormErrors = Record<
  keyof RegisterDeliveryInformationFormValues,
  { hasError: true; errorMessage: string } | { hasError: false }
>

export type RegisterDeliveryInformationFormState = {
  values: RegisterDeliveryInformationFormValues
  errors: RegisterDeliveryInformationFormErrors
}
